import {
  BreakpointAction,
  ChoiceFunction,
  ConsideringPurchaseOption,
  EligibleAppleWatchBreakpointOption,
  NightSleepBreakpointOption,
  PurchaseNewWatchOption,
  QuizDataInput,
  WhichWearableBreakpointOption,
} from '@naturalcycles/shared'
import { Page } from '@src/app/shared/typings/enum/pages.js'
import { allQuizSections } from '../quiz.js'

const commonTransformFunction: ChoiceFunction<Page, QuizDataInput> = (flow, data) => {
  const appleWatch = data?.whichWearable?.includes(WhichWearableBreakpointOption.appleWatch)
  const ouraUser = data?.whichWearable?.includes(WhichWearableBreakpointOption.ouraRing)
  const sleepsThroughTheNight =
    data?.nightSleep === NightSleepBreakpointOption.sleepsThroughTheNight
  const isAppleWatchEligible = data?.eligibleAppleWatch === EligibleAppleWatchBreakpointOption.yes
  const isWillingToPurchaseAW =
    data?.purchaseNewWatch === PurchaseNewWatchOption.yes ||
    data?.consideringPurchase === ConsideringPurchaseOption.yesAppleWatch

  flow[allQuizSections.routine] = [
    Page.naturalMethod,
    Page.yourMeasuringDevice,
    Page.whichWearable,
    Page.equallyEffectiveInfo,
    ...(appleWatch
      ? [Page.eligibleAppleWatch, Page.equallyEffectiveInfo]
      : [Page.equallyEffectiveInfo]),
    Page.nightSleep,
    ...(sleepsThroughTheNight
      ? [Page.sleepWearable]
      : [Page.troubleGettingBackToSleep, Page.sleepWearable]),
    ...((isAppleWatchEligible || isWillingToPurchaseAW) && !ouraUser
      ? [Page.wearYourWatchToBed, Page.sleepConsistency]
      : [Page.sleepConsistency]),
    Page.spendingDaysInfo,
    Page.healthGoals,
    Page.feelingStressed,
    Page.biggestStressor,
    Page.favoriteWayToUnwind,
    Page.deviceTrait,
    Page.resultOverview,
  ]
  return flow
}

export const nightSleep: BreakpointAction<NightSleepBreakpointOption, Page, QuizDataInput> = {
  [NightSleepBreakpointOption.sleepsThroughTheNight]: commonTransformFunction,
  [NightSleepBreakpointOption.sometimesWakesUp]: commonTransformFunction,
  [NightSleepBreakpointOption.oftenWakesUp]: commonTransformFunction,
}
